import { useEffect, useState } from "react";

const useStickySwitcher = (
  observedSelector: string,
  triggerMargin = "0px",
) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const element = document.querySelector(observedSelector);
    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setIsSticky(entry.isIntersecting),
      { threshold: 0, rootMargin: triggerMargin },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [observedSelector, triggerMargin]);

  return isSticky;
};

export default useStickySwitcher;